/** Main henüz Chatflow kolonlarını tanımıyorsa alert ayarını WebHookUrl içinde saklar. */
export const CHATFLOW_ALERT_PREFIX = "__ROBBOT_CF__:";

export function encodeChatflowAlertPayload({ channelId, contactIds, message }) {
  const payload = {
    channelId,
    contactIds: Array.isArray(contactIds) ? contactIds : [],
    message: message || "",
  };
  return CHATFLOW_ALERT_PREFIX + btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
}

export function decodeChatflowAlertPayload(webHookUrl) {
  if (!webHookUrl || typeof webHookUrl !== "string" || !webHookUrl.startsWith(CHATFLOW_ALERT_PREFIX)) {
    return null;
  }
  try {
    const json = decodeURIComponent(escape(atob(webHookUrl.slice(CHATFLOW_ALERT_PREFIX.length))));
    const data = JSON.parse(json);
    if (!data.channelId || !data.contactIds?.length) return null;
    return data;
  } catch (e) {
    return null;
  }
}

export function isChatflowWebhookSlot(webHookUrl) {
  return typeof webHookUrl === "string" && webHookUrl.startsWith(CHATFLOW_ALERT_PREFIX);
}
